import { QueryStringArgumentSerializer } from "./QueryStringArgumentSerializer";
import { MultipleValuesArgumentSerializer } from "./MultipleValuesArgumentSerializer";
import { logger } from "../../../logging/logger";

const keyValueSeparator = ':'
const valueListSeparator = '|'
const pairSeparator = ','
const commaReplacement = '{COMMA}';

export interface DealClassesArgument {
    label: string
    dealReferenceName: string
    classNames: string[]
}


// Item format: DealReferenceName:Label:Class1|Class2|...ClassN(Optional)
// List Format: Item1,Item2...ItemN
export class DealClassesArgumentSerilizer extends
    QueryStringArgumentSerializer<DealClassesArgument[]> {

    private normalize(value: string) {
        return encodeURIComponent(value.replaceAll(/,/g, '\\,'));
    }

    serializeItem({ dealReferenceName, label, classNames }: DealClassesArgument) {
        const keySegment = this.normalize(dealReferenceName);
        const labelSegment = this.normalize(label);
        const separator = this.normalize(keyValueSeparator);
        const valueSegment = classNames.length
            ? new MultipleValuesArgumentSerializer('', []).serialize(classNames)
            : undefined;

        if (valueSegment) {
            return keySegment + separator + labelSegment + separator + valueSegment;
        }

        return keySegment + separator + labelSegment;

    }

    serialize = (value?: DealClassesArgument[]) => {
        if (!value?.length) {
            return undefined;
        }

        try {
            return value
                .map(item => this.serializeItem(item))
                .join(pairSeparator)
        } catch (e) {
            logger.exception(e, 'failed to serialize DealClassesArgument',)
            return undefined;
        }
    }

    deserializeItem = (item: string) => {
        const [dealReferenceName, label, classNamesString = ''] = item.split(keyValueSeparator);

        if (!dealReferenceName?.trim() || !label?.trim()) return undefined;

        const classNames = classNamesString.split(valueListSeparator);

        return { dealReferenceName, label, classNames };
    }

    deserialize(rawValue: string) {
        try {
            const result = rawValue
                .replaceAll('\\,', commaReplacement)
                .split(',')
                .map(value => value.replaceAll(commaReplacement, ','))
                .map(value => value.trim())
                .filter(value => value)
                .map(value => decodeURIComponent(value))
                .map(value => this.deserializeItem(value))
                .filter(x => x) as DealClassesArgument[];

            if (result.length) {
                this.onDeserializeCallback?.(result);
            }
        } catch (e) {
            logger.exception(e, 'failed to deserialize: ' + rawValue);
        }
    }
}